import { ProfileAdvancedSearchParams } from './profile-advanced-search-params.model';
import { ProfileSearchResult } from './profile-search-result.model';

export class ProfileSearchComponentModel {
  public selectAllProfiles: boolean;
  public selectedProfiles: Array<number>;
  public showAdvancedSearch: boolean;
  public profiles: ProfileSearchResult;
  public searchParams: ProfileAdvancedSearchParams;
  public userNum: string;
  public clientId: string;

  public constructor() {
    this.profiles = new ProfileSearchResult();
    this.searchParams = new ProfileAdvancedSearchParams();
    this.selectedProfiles = new Array<number>();
    this.selectAllProfiles = false;
    this.showAdvancedSearch = false;
    this.clientId = '';
    this.userNum = '';
  }
}
